<template>
  <div
    data-animate="listing-filters"
    class="listing-filters m-top-6"
    ref="filters"
  >
    <button class="listing-filters__button" @click="toggleDropdown">
      <span class="text-m"
        >{{ $t(`listing.filters`) }}
        <small class="listing-filters__count" v-if="selectedFilters.length">{{
          selectedFilters.length
        }}</small></span
      >
      <img
        src="~/assets/img/ico/ico-arrow-down-dark.svg"
        alt="Ico arrow down dark"
        width="12"
        height="13"
        data-animate="listing-filters-ico"
      />
    </button>
    <div
      class="listing-filters__dropdown"
      data-animate="listing-filters-dropdown"
    >
      <div class="listing-filters__dropdown__content">
        <ListingFiltersButtons
          :families="props.families"
          @selected="onFilterSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingFilters',
}
</script>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits(['selected'])

const route = useRoute()

const props = defineProps({
  families: Array,
})

const filters = ref(null)
const active = ref(false)

const selectedOnLoad = route.query?.categories
  ? [].concat(route.query?.categories)
  : []

const selectedFilters = ref(selectedOnLoad)

const tl = ref(null)

onMounted(() => {
  tl.value = animate()

  document.addEventListener('click', (event) => {
    // Check if the clicked element is the one you want to target
    if (!event.target.closest('.listing-filters')) {
      active.value = false
    }
  })
})

watch(
  () => active.value,
  (active) => {
    active ? tl.value.play() : tl.value.reverse()
  }
)

// quando selezioni un filtro
const onFilterSelected = (selected) => {
  selectedFilters.value = selected
  emit('selected', selectedFilters.value)
}

const toggleDropdown = () => {
  active.value = !active.value
}

// Animazioni
const animate = (params) => {
  const duration = 0.6

  const parent = filters.value
  const dropdown = parent.querySelectorAll(
    '[data-animate="listing-filters-dropdown"]'
  )
  const ico = parent.querySelectorAll('[data-animate="listing-filters-ico"]')
  const links = parent.querySelectorAll('[data-animate="listing-filters-link"]')

  const tl = gsap.timeline({
    paused: true,
    ...params,
  })

  tl.set(dropdown, {
    autoAlpha: 1,
  })
  tl.to(
    dropdown,
    {
      height: 'auto',
      ease: 'power1.out',
    },
    'start'
  )
  tl.to(
    ico,
    {
      rotation: 180,
    },
    'start'
  )
  tl.to(
    links,
    {
      y: '0%',
      stagger: 0.05,
    },
    'start'
  )

  tl.totalDuration(duration)

  return tl
}
</script>

<style lang="scss">
@import './style.scss';
</style>
